<script lang="ts">export let title;
</script>

<h2 class="vip-section-title">{title}</h2>

<style>
	.vip-section-title {
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 600;
    color: var(--color-accent-500)
}
</style>
